import Vuex from "vuex";
import axios from "axios";
import {trackingPushLocationFocus} from "./tracking";

export default (token, url) => {
    return new Vuex.Store({
        state: {
            activeTab: 'retail',
            formOpen: true,
            filterOpen: false,
            resultOpen: false,
            results: [],
            categories: [],
            bearer: token,
            url: url,
            http: axios.create({
                baseURL: url,
                headers: { Authorization: `Bearer ${token}` }
            }),
            focusId: null
        },
        mutations: {
            setFocus(state, id) {
                state.focusId = id
            },
            setFilterOpenState(state, openState) {
                state.filterOpen = openState
            },
            setFormOpenState(state, openState) {
                state.formOpen = openState;
            },
            setResultOpenState(state, openState) {
                state.resultOpen = openState;
            },
            updateResults(state, data) {
                state.results = data;
            },
            setTab(state, tab) {
                state.activeTab = tab;
            },
            clearResultFocus(state) {
                state.focusId = null;
                state.results.forEach(r => {
                    r.focus = false;
                });
            },
            setResultFocus(state, result) {
                state.results.forEach(r => {
                    if (r === result) {
                        trackingPushLocationFocus(r);
                        r.focus = true;
                    }
                });
            }
        },
        actions: {
            async fetchPosProducts(ctx) {
                //Hier alle Categories fetchen, darunter Sorten und Gebinde
                //const res = await ctx.state.http.get('/categories');
                const res = await ctx.state.http.get('/category');
                // const res = await ctx.state.http.get('/productGroups');
                if (!res.data || !res.data.data) {
                    ctx.state.categories = [];
                }
                /*ctx.state.categories = res.data.data.map(c => {
                    return {
                        ...c,
                        product_groups: {
                            ...c.productGroups.map(pg => {
                                return {
                                    ...pg,
                                    products: pg.products.sort((a, b) => {
                                        if (a.position === b.position) {
                                            return a.name.localeCompare(b.name);
                                        }
                                        return a.position - b.position;
                                    })
                                }
                            })
                        }
                    };
                });*/

                ctx.state.categories = res.data.data;
                //with only 2 selects
                /*ctx.state.productGroups = res.data.data.map(b => {
                    return {
                        ...b,
                        products: b.products.sort((a, b) => {
                            if (a.position === b.position) {
                                return a.name.localeCompare(b.name);
                            }
                            return a.position - b.position;
                        })
                    };
                });*/
            },
            async executePosSearch(ctx, query) {
                // Build Search Query
                const search = {
                    distance: query.distance + "km"
                };
                if (query.category) {
                    search.category = query.category;
                }
                if (query.productGroup) {
                    search.productGroup = query.productGroup;
                }
                if (query.product) {
                    search.product = query.product;
                }
                if (query.coords) {
                    search.latitude = query.coords.lat;
                    search.longitude = query.coords.lon;
                } else {
                    search.query = query.query + ' germany';
                }
                const searchQuery = new URLSearchParams(search).toString();
                // Make HTTP Request
                const res = await ctx.state.http.get("/geo_distance?" + searchQuery);
                const resList = res?.data?.results || [];

                // Build locations objects
                const locations = resList.map(res => {
                    return {
                        id: res.model.id,
                        type: res.model.location_type_id === 1 ? 'retail' : 'gastro',
                        title: res.model.name,
                        street: res.model.address,
                        no: "",
                        zip: res.model.zip_code,
                        city: res.model.city,
                        coords: {
                            lat: parseFloat(res.model.latitude),
                            lon: parseFloat(res.model.longitude)
                        },
                        distance: res.model.distance_in_km,
                        focus: false
                    }
                });

                // Push locations
                ctx.commit('updateResults', locations);
            }
        }
    });
}
